import { registerAgGridEnterpriseModules } from '@rcs/shared';
import { AppModule } from './app/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

registerAgGridEnterpriseModules();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));